function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-4",
  transform: "translate(-1313.000000, -797.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M1339.66667,797 L1316.33333,797 C1314.48333,797 1313,798.5 1313,800.333333 L1313,823.666667 C1313,825.5 1314.48333,827 1316.33333,827 L1339.66667,827 C1341.5,827 1343,825.5 1343,823.666667 L1343,800.333333 C1343,798.5 1341.5,797 1339.66667,797 Z M1336.33333,813.666667 L1329.66667,813.666667 L1329.66667,820.333333 L1326.33333,820.333333 L1326.33333,813.666667 L1319.66667,813.666667 L1319.66667,810.333333 L1326.33333,810.333333 L1326.33333,803.666667 L1329.66667,803.666667 L1329.66667,810.333333 L1336.33333,810.333333 L1336.33333,813.666667 Z",
  id: "Shape"
})));

var SvgZoomIn = function SvgZoomIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-in.54412e29.svg";
export { ForwardRef as ReactComponent };